import {
  GetMyAbsencesSuccess,
  GetMyAbsencesSchemaSuccess,
  GetMyAbsenceSuccess,
} from "@modules/profile/constants/actions";
import type { MyAbsencesState } from "./types";
import { cloneObject } from "@utils/object";

export const initialState: MyAbsencesState = {
  requestsInProgress: 0,
  list: {
    content: [],
    pagination: {
      sort: { orders: [] },
      pageNumber: 0,
      pageSize: 0,
      offset: 0,
    },
    totalElements: 0,
  },
  modals: {
    addAbsence: {
      visible: false,
      editing: false,
      absence: {},
    },
  },
  absencesSchema: {},
  absenceDetails: {},
};

export const onGetMyAbsencesSuccess = (state: MyAbsencesState) => ({ payload }: Object) => {
  return {
    ...state,
    error: null,
    absences: payload,
  };
};

export const onGetMyAbsencesSchemaSuccess = (state: MyAbsencesState) => ({ payload }: Object) => {
  return {
    ...state,
    absencesSchema: payload,
  };
};

export const onGetMyAbsenceSuccess = (state: MyAbsencesState) => ({ payload }: Object) => {
  return {
    ...state,
    absenceDetails: payload,
  };
};

export default (state: MyAbsencesState = initialState, action: Object): MyAbsencesState => {
  const act = {
    [GetMyAbsencesSuccess]: onGetMyAbsencesSuccess,
    [GetMyAbsencesSchemaSuccess]: onGetMyAbsencesSchemaSuccess,
    [GetMyAbsenceSuccess]: onGetMyAbsenceSuccess,
  };
  if (action && action.type && act && act[action.type]) {
    return act[action.type](cloneObject(state))(action);
  }
  return state;
};
